















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import TableRowItem from './TableRowItemInterface';

@Component({})
export default class TableRow extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: TableRowItem;

  @Prop({ type: Boolean, required: true })
  readonly isActive!: boolean;

  get compTableLineStyle(): string {
    return this.isActive ? 'table-line-color-active' : 'table-line-color-inactive';
  }
}
